import React, {useEffect, useState} from 'react';
import {InterfaceCreateAccountMailing} from "../../../../views/CreateAccount/CreateAccountMailing/CreateAccountMailing";
import FCSelect from "../../../FCObjets/Form/FCSelect";

export interface InterfaceAccountMailing {
    serverSMTP: string;
    userSmtp: string;
    passSMTP: string;
}

export type AccountMailingUserProps = {
    handlerChange: (dataMailing: InterfaceAccountMailing) => void;
    data: InterfaceAccountMailing;
    listServerSmtp: [{ name: string }];
}

const FormAccountMailing: React.FC<AccountMailingUserProps> = ({handlerChange, data, listServerSmtp}) => {

    const [dataMailing, setDataMailing] = useState<InterfaceAccountMailing>(data);
    const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

    useEffect(() => {
        if (listServerSmtp) {
            setOptions(listServerSmtp.map((s) => ({value: s.name, label: s.name})));
        }
    }, [listServerSmtp]);

    const eventChange = (key: keyof InterfaceCreateAccountMailing, value: string) => {
        const v: InterfaceAccountMailing = {...dataMailing, [key]: value};
        setDataMailing(v);
        handlerChange(v);
    };

    return (
        <>
            <div className="configField">
                <label>Serveur SMTP</label>
                <FCSelect
                    options={options}
                    value={dataMailing.serverSMTP}
                    onChange={(v) => eventChange("serverSMTP", String(v))}
                    placeholder="Sélectionner un serveur"
                />
            </div>

            <div className="configField configFieldIcon">
                <label htmlFor="userSmtp">Utilisateur SMTP</label>
                <span className="material-symbols-outlined">person</span>
                <input id="userSmtp" type="text" value={dataMailing.userSmtp}
                       placeholder="utilisateur@exemple.fr"
                       onChange={(e) => eventChange("userSmtp", e.target.value)}/>
            </div>

            <div className="configField configFieldIcon">
                <label htmlFor="passSmtp">Mot de passe SMTP</label>
                <span className="material-symbols-outlined">lock</span>
                <input id="passSmtp" type="password" value={dataMailing.passSMTP}
                       placeholder="••••••••"
                       onChange={(e) => eventChange("passSMTP", e.target.value)}/>
            </div>
        </>
    );
};

export default FormAccountMailing;
